import api, { ValidateAxiosError, } from '@/modules/api.service';
import { CreateHolidayDto, ReadHolidayResponseDto, UpdateHolidayDto } from '@/api.types';
import { Endpoints } from '@/shared/constants/endpoints';
import { FindHolidayOptionsDto } from '@/api.types.extra';

const endpoint = Endpoints.FERIADO;

export async function createHoliday(dto: CreateHolidayDto) {
  try {
    const response = await api.post<number>(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao cadastrar a bloqueio.');
  }
}

export async function readHoliday(filters: FindHolidayOptionsDto) {
  if (filters) {
    filters.skip ??= 0;
    filters.take ??= 10;
  }

  try {
    const response = await api.get<[ReadHolidayResponseDto[], number]>(endpoint, { params: filters });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar bloqueio(s).');
  }
}

export async function updateHoliday(dto: UpdateHolidayDto) {
  try {
    const response = await api.put<ReadHolidayResponseDto>(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao atualizar a bloqueio.');
  }
}

export async function deleteHoliday(id: number) {
  try {
    const response = await api.delete(endpoint + '/' + id)
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao remover a bloqueio.');
  }
}